import { RowAction } from '../components/Table/models';
import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
  components: {
    accordionFilter: {
      clearFilter: {
        iconProps: {
          asset: 'base.dialog.close',
        },
        show: true,
      },
    },
    app: {
      noDataOptions: {
        noDataPlaceholder: 'Found 0 results - please try another search term and/or filter selection'
      },
      cardProps: {
        props: {
          subtitle:
            'Search and download your documents here. You can filter by type, date, and create saved searches.',
          title: 'Document Hub',
        },
      },
      documentSearchRequest: {
        limit: 50,
        search: [],
        sort: {
          direction: 'ASC',
          key: 'document_type',
        },
      },
      filename: {
        queryOptionsType: 'none',
        subQueries: [
          {
            key: 'title',
            queryId: 'title',
            queryOptionsType: 'response',
          },
          {
            key: 'meta.isin.value',
            queryId: 'isin',
            queryOptionsType: 'response',
          },
        ],
        value: '{sub:title}{sub:isin}',
      },
      searchType: 'faceted',
    },
    bulkDownload: {
      badge: {
        show: true,
      },
    },
    bulkUrlCopy: {
      badge: {
        show: true,
      },
      buttonText: 'Copy URL button text',
      copyUrlOptions: {
        query: {
          queryOptionsType: 'none',
          subQueries: [
            {
              key: 'URL',
              queryId: 'clientCode',
              queryOptionsType: 'document',
            },
          ],
          value: 'https://www.nordea.lu/documents/{sub:clientCode}',
        },
      },
      separator: '\n',
      show: true,
    },
    clearSearchAndFilters: {
      buttonText: 'Clear Search & Filters',
      show: true,
    },
    dateSearch: {
      dateRangeInputProps: {
        dateFieldItems: [
          {
            label: 'Created By',
            value: 'created',
          },
          {
            label: 'Last Modified By',
            value: 'lastModified',
          },
        ],
        formatting: {
          dateInputFormat: {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          },
          locale: 'en-GB',
          selectedDateFormat: {
            dateFormatString: 'ddd, MMM DD',
          },
        },
      },
    },
    exportToCsv: {
      columns: [
        {
          format: {
            options: {
              day: '2-digit',
              month: '2-digit',
              placeholderKey: 'date',
              placeholderText: 'as at {date}',
              year: 'numeric',
            },
            type: 'date',
          },
          header: 'Created2',
          id: 'created',
          key: 'created',
          tableColumnId: 'created',
        },
        {
          id: 'inferredTest',
          key: 'inferredTest',
          tableColumnId: 'inferredTest',
        },
        {
          id: 'inferredTest2',
          key: 'inferredTest2',
          tableColumnId: 'inferredTest2',
        },
        {
          id: 'clientCode',
          key: 'clientCode',
          tableColumnId: 'clientCode',
        },
        {
          id: 'title',
          key: 'title',
          tableColumnId: 'title',
        },
        {
          id: 'documentType',
          key: 'documentType',
          tableColumnId: 'documentType',
        },
        {
          id: 'document_category',
          key: 'document_category',
          tableColumnId: 'document_category',
        },
        {
          id: 'cultureCode',
          key: 'cultureCode',
          tableColumnId: 'cultureCode',
        },
        {
          header: 'ISIN2',
          id: 'isin',
          key: 'isin',
          valueQuery: {
            childKey: 'isin',
            key: 'meta',
            queryOptionsType: 'document',
          },
        },
      ],
      filenameQuery: {
        queryOptionsType: 'none',
        subQueries: [
          {
            options: {
              dynamic: {
                key: 'date',
              },
            },
            queryId: 'date',
            queryOptionsType: 'dynamic',
          },
        ],
        value: 'Document Meta {sub:date}',
      },
      separator: ',',
      show: true,
    },
    facetedSearch: {
      allowedFields: ['filename', 'document_type', 'title', 'cultureCode', 'regions'],
      queryString: {
        enabled: true,
      },
      searchDocumentsLimits: {
        excludeFacetedSearch: true,
      },
    },
    feedback: {
      mode: 'toast',
      displaySeconds: 3
    },
    filters: {
      activeFiltersProps: {
        heading: 'Active filters',
        show: true,
      },
      breakpoints: [
        {
          modifier: 'down',
          props: {
            mode: 'accordion',
          },
          size: 'small',
        },
        {
          modifier: 'up',
          props: {
            mode: 'dropdown',
          },
          size: 'medium',
        },
      ],
      childFilters: [
        {
          code: 'document_category',
          label: 'Category',
        },
        {
          code: 'document_type',
          label: 'Document Type',
          searchInput: {
            caseSensitive: true,
            enable: true,
            minItems: 0,
            placeholder: 'Filter items',
          },
        },
        {
          code: 'regions',
          label: 'Regions',
          searchInput: {
            caseSensitive: true,
            enable: true,
            minItems: 3,
            placeholder: 'Filter items',
          },
        },
      ],
      indicatorText: {
        multipleFilters: '{total} filter(s) selected',
        noFilters: 'No filters selected',
      },
      pinSelected: true,
      queryString: {
        enabled: true,
      },
      useCounts: true,
    },
    identifierSearch: {
      definitions: [
        {
          properties: ['document_type', 'document_category'],
          target: 'document',
        },
      ],
      iconProps: {
        asset: 'base.search.magnificationGlass',
      },
      placeholder: 'Search document type or category...',
    },
    paging: {
      initialPageSize: 10,
    },
    savedSearch: {
      listPagingSize: 2,
    },
    table: {
      actions: {
        copyUrl: {
          key: 'copy-url',
          label: 'Copy URL',
        },
        download: {
          key: 'download',
          label: 'Download',
        },
        preview: {
          key: 'preview',
          label: 'Preview',
        },
      },
      actionsType: 'buttons',
      columns: [
        {
          header: 'Year',
          id: 'year',
          key: 'year',
          valueQuery: {
            format: {
              options: {
                dateFormatString: 'YYYY',
                year: 'numeric',
              },
              type: 'date',
            },
            key: 'lastModified',
            queryOptionsType: 'document',
          },
        },
        {
          header: 'Client Code',
          id: 'clientCode',
          key: 'clientCode',
          valueQuery: {
            key: 'clientCode',
            queryOptionsType: 'document',
          },
        },
        {
          header: 'Title',
          id: 'title',
          key: 'title',
          sort: {
            enabled: true,
          },
          valueQuery: {
            key: 'title',
            queryOptionsType: 'document',
          },
        },
        {
          header: 'Document Type',
          id: 'documentType',
          key: 'documentType',
          sort: {
            enabled: true,
          },
          valueQuery: {
            childKey: 'document_type',
            key: 'meta',
            queryOptionsType: 'document',
          },
        },
        {
          header: 'Culture',
          id: 'cultureCode',
          key: 'cultureCode',
          valueQuery: {
            key: 'cultureCode',
            queryOptionsType: 'document',
          },
        },
      ],
      copyUrlOptions: {
        iconOptions: {
          filename: {
            src: 'FingerPrintIcon.svg'
          },
          successFilename: {
            src: 'SuccessIcon.svg'
          },
          displaySeconds: 1
        },
        query: {
          queryOptionsType: 'none',
          subQueries: [
            {
              key: 'URL',
              queryId: 'clientCode',
              queryOptionsType: 'document',
            },
          ],
          value: 'https://www.nordea.lu/documents/{sub:clientCode}',
        },
      },
      grouping: {
        autoExpandAllGroups: false,
        autoExpandGroupsByField: ['KIID'],
        field: 'documentType',
        sort: {
          direction: 'ASC',
          key: 'documentType',
        },
        tableGrouping: {
          alignExpander: 'right',
          cardGroupingStyle: {
            background: {
              color: '#0000A0',
            },
            color: 'white',
          },
          getRowsQuery: {
            options: {
              documents: {
                collectionItemValueConditional: {
                  conditions: [
                    {
                      field: 'meta.document_type.value',
                      valueQuery: {
                        options: {
                          response: {
                            key: 'row.documentType',
                          },
                        },
                        queryOptionsType: 'response',
                      },
                    },
                  ],
                },
              },
            },
            queryOptionsType: 'documents',
          },
          headingKey: 'documentType',
          id: 'documents',
          rowStyle: {
            background: {
              color: '#efefef',
            },
          },
        },
      },
      showGroupCheckboxes: true,
    },
  },
  core: {
    endpointsConfiguration: {
      endpoints: {
        documents: {
        },
      },
    },
  },
  culture: {
    base: 'en-GB',
    default: 'en-GB',
  },
};